export const getBoardsWithWorkspaceQuery = ({ page = 1, limit = 50 }: { page?: number; limit?: number } = {}) => {
  return `{
        boards(limit: ${limit}, order_by: used_at, page: ${page}) {
        workspace {
            id
            name
            settings {
            icon {
                color
                image
            }
            }
        }
        }
    }`;
};
